module.exports = __webpack_public_path__ + "img/success.545956fe.png";